import { TTypeOfErrorModalWindow, TTypeOfModalWindow } from './styleSettingsImageUploaderContext';

export enum StyleSettingsImageUploaderActionTypes {
	SET_LOADING = 'SET_LOADING',
	SET_UPLOADER_SRC = 'SET_UPLOADER_SRC',
	SET_CROPPER_SRC = 'SET_CROPPER_SRC',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	CHANGE_TYPE_OF_ERROR_MODAL_WINDOW = 'CHANGE_TYPE_OF_ERROR_MODAL_WINDOW',
	SET_LOADING_IMAGE_ERROR = 'SET_LOADING_IMAGE_ERROR',
	SET_NEW_IMAGE_UPLOADED = 'SET_NEW_IMAGE_UPLOADED',
}

interface ISetLoading {
	type: StyleSettingsImageUploaderActionTypes.SET_LOADING;
	payload: {
		isLoading: boolean;
	};
}

interface ISetUploaderSrc {
	type: StyleSettingsImageUploaderActionTypes.SET_UPLOADER_SRC;
	payload: {
		src: string | null;
	};
}

interface ISetCropperSrc {
	type: StyleSettingsImageUploaderActionTypes.SET_CROPPER_SRC;
	payload: {
		src: string | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: StyleSettingsImageUploaderActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

interface IChangeTypeOfErrorModalWindow {
	type: StyleSettingsImageUploaderActionTypes.CHANGE_TYPE_OF_ERROR_MODAL_WINDOW;
	payload: {
		typeOfErrorModalWindow: TTypeOfErrorModalWindow;
	};
}

interface ISetLoadingImageError {
	type: StyleSettingsImageUploaderActionTypes.SET_LOADING_IMAGE_ERROR;
	payload: {
		loadingImageError: boolean;
	};
}

interface ISetNewImageUploaded {
	type: StyleSettingsImageUploaderActionTypes.SET_NEW_IMAGE_UPLOADED;
	payload: {
		isNewImageUploaded: boolean;
	};
}

export type TStyleSettingsImageUploaderAction =
	| ISetLoading
	| ISetUploaderSrc
	| ISetCropperSrc
	| IChangeTypeOfModalWindow
	| IChangeTypeOfErrorModalWindow
	| ISetLoadingImageError
	| ISetNewImageUploaded;
